/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:3eb3921d-2c08-454b-bef2-52ae4a8c94a2",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Zz0qhNJC1",
    "aws_user_pools_web_client_id": "6ri99fuanjm16uc79da3ehlo8d",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Pets-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "SupportTickets-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "lpp_inventory-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "lpp_orders-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "lpp_pet_health-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "lpp_rate_limits-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "lpp_stripe_events-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "lpp_subscriptions-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "lpp_tag_batches-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "lpp_tags-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "lpp_x_reply_que-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "lpp_x_state-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "petNote-dev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "littlepawsplace-petphotosf575f-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
